import React from 'react'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import LinkDarkButton from '../components/LinkDarkButton'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Slide from '@material-ui/core/Slide'
import { injectIntl } from 'react-intl'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { nextSurveySelector } from '../redux/selectors'
import { Paper } from '@material-ui/core'

const TopHeader = ({ intl, nextSurvey }) => {
	return (
		nextSurvey && (
			<Paper data-testid="top-header-alert" style={{ overflow: 'hidden', width: '100%', background: '#F54337' }} square={true}>
				<Slide data-testid="top-header-slide" direction='down' in={true} mountOnEnter unmountOnExit>
					<Toolbar style={{ margin: '0 auto' }}>
						<Grid container direction='column' style={{ padding: '10px 0px' }}>
							<Grid item style={{ textAlign: 'center' }}>
								<Typography
									data-testid="top-header-survey-due"
									style={{
										color: 'white',
										fontSize: '16px'
									}}>
									{intl.formatMessage({
										id: 'app.dashboard.surveyDue'
									})}
								</Typography>
							</Grid>
							<Grid item style={{ textAlign: 'center' }}>
								<LinkDarkButton
									data-testid="top-header-survey-link"
									textId='app.dashboard.completeNow'
									variant='contained'
									color='white'
									backgroundColor='#11121C'
									path={`/survey/${nextSurvey.caseId}/${nextSurvey.protocolId}/${nextSurvey.instanceId}/${nextSurvey.surveyId}`}
								/>
							</Grid>
						</Grid>
					</Toolbar>
				</Slide>
			</Paper>
		)
	)
}

const mapStateToProps = (state, ownProps) => ({
	nextSurvey: nextSurveySelector(state)
})

const mapDispatchToProps = (dispatch, ownProps) => ({})

const enhance = compose(connect(mapStateToProps, mapDispatchToProps), injectIntl)

export default enhance(TopHeader)
